module.exports = __webpack_public_path__ + "fonts/DINPro-Black.93bbb050.ttf";